import { faqs } from '@/mocks/chiguaData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-2">
            吃瓜问答
          </h2>
          <p className="text-sm text-foreground-500">关于91在线吃瓜，你想知道的都在这里</p>
        </div>

        <div className="max-w-[800px] mx-auto grid gap-4">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="rounded-xl bg-background-50 border border-background-200/70 p-5 md:p-6"
            >
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 text-sm font-bold mt-0.5">
                  Q
                </span>
                {faq.question}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed pl-9">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}